// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-theme[data-v-0a2ff8be] .d2-container-full .d2-container-full__body{\r\n  background-color: rgba(255,255,255,0.4) !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
